var rp = require('request-promise').defaults({json: true})

let inter = (typeof window.location.href.split('?')[1] == "undefined" || window.location.href.split('?')[1] == "")? '1' : window.location.href.split('?')[1];
const api_root = 'https://me-ta-proplus.com/chart/history_NAS100/'+inter+'.asp'
const history = {}

export default {
	history: history,

    getBars: function(symbolInfo, resolution, from, to, first, limit) {

		//var split_symbol = symbolInfo.name.split(/[:/]/)
		//console.log('split_symbol = ' + symbolInfo.name)
		
        return rp({
                url: `${api_root}`
            })
            .then(data => {
                //console.log(data.length)
			
				if (data.length) {
					//console.log(`Actually returned: ${new Date(data.TimeFrom * 1000).toISOString()} - ${new Date(data.TimeTo * 1000).toISOString()}`)
					var bars = data.map(el => {
						//console.log(el.time * 1000);
						return {
							time: el.time * 1000, //TradingView requires bar time in ms
							low: el.low,
							high: el.high,
							open: el.open,
							close: el.close,
							//volume: el.volumefrom 
						}
					})
						if (first) {
							var lastBar = bars[bars.length - 1]
							history[symbolInfo.name] = {lastBar: lastBar}
						}
					return bars
				} else {
					return []
				}
			})
	}
}



// WEBPACK FOOTER //
// ./src/components/TVChartContainer/api/historyProvider.js